/* eslint-disable react/no-danger */
import React from "react";

const HTMLContent = ({ html }) => {
  return (
    <div className="my-5 md:my-6 lg:my-8">
      <div
        className="prose sm:prose lg:prose-lg tracking-tighter md:tracking-tight lg:tracking-normal"
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </div>
  );
};

export default HTMLContent;
